import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { JobsService } from '../../../services/jobs.service';
import { TaskService } from '../../../services/task.service';

@Component({
    standalone: false,
    selector: 'app-remove-process-button',
    templateUrl: './remove-process-button.component.html',
    styleUrls: ['./remove-process-button.component.scss']
})
export class RemoveProcessButtonComponent implements OnInit {
    @Input()
    process: ITaskModel;

    @Input()
    isTask?: boolean;

    @Input()
    deleteProcessEmitter: EventEmitter<boolean>;

    constructor(
        private readonly dialog: MatDialog,
        private readonly jobsService: JobsService,
        private readonly taskService: TaskService
    ) {}

    ngOnInit(): void {}

    deleteJob(event) {
        event.stopPropagation();

        const deleteDialogConfig = new MatDialogConfig();
        deleteDialogConfig.autoFocus = true;
        deleteDialogConfig.data = {
            title: this.isTask ? 'Delete Task' : 'Delete Job',
            topContent: this.isTask
                ? `This operation can't be undone. Continue?`
                : `This operation can't be undone. All related data in DB and on S3 will be deleted.
  Continue?`
        };

        const recalculateDialogRef = this.dialog.open(ConfirmationDialogComponent, deleteDialogConfig);
        recalculateDialogRef.afterClosed().subscribe(startRecalculation => {
            if (!startRecalculation) {
                return;
            }
            this.isTask
                ? this.taskService.deleteTask(this.process).subscribe()
                : this.jobsService.deleteJob(this.process);

            if (this.deleteProcessEmitter) {
                this.deleteProcessEmitter.emit(true);
            }
        });
    }
}
